import { DatePipe, ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ITimeSlot } from 'src/app/interfaces/i-time-slot';
import { Session } from 'src/app/models/session';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { SessionsService } from 'src/app/services/sessions.service';
import { UserService } from 'src/app/services/user.service';
import { SessionFormComponent } from '../form-session/session-form.component';
import { AlertController, IonContent, ModalController } from '@ionic/angular';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-list-session-bis',
  templateUrl: './list-session-bis.component.html',
  styleUrls: ['./list-session-bis.component.scss'],
  animations: [
    trigger('highlightAnimation', [
      state('inactive', style({ "font-size": 'larger' })),
      state('active', style({ "font-size": '25px' })),
      transition('inactive <=> active', animate('0.5s'))
    ])
  ]
})
export class ListSessionBisComponent implements OnInit {


  spinner: boolean = false;

  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;


  constructor(
    public apiProvider: ApiProviderService,
    public userService: UserService,
    public datePipe: DatePipe,
    public sessionService: SessionsService,
    public modalCtrl: ModalController,
    private scroller: ViewportScroller,
    public alertController: AlertController
  ) { }

  ngOnInit() {
    this.availableSlot();

  }

  ionViewDidEnter() {

    // Écouter l'événement ionBackdropTap
    this.modalCtrl.getTop().then(modalInstance => {
      modalInstance.onWillDismiss().then(async data => {

        if (data.role === 'backdrop') {

          let rtnDatas = {
            date: this.sessionService.selectedDate,
            countSession: this.sessionService.slots.filter(objet => objet.type === 0).length
          }

          data.data = rtnDatas;
          this.cancelSelection();
        }
      });
    });
  }

  // Fonction pour fermer la modal avec des données
  async closeModalWithData(data: any) {
    // Fermer la modal avec les données spécifiées
    await this.modalCtrl.dismiss(data);
  }

  availableSlot(duration: number = 60, scrollToSession: Session | number = null) {
    this.spinner = true;
    this.apiProvider.getSchedulesPerDay(this.userService.getUser().id, this.datePipe.transform(this.sessionService.selectedDate, 'yyyy-MM-dd H:mm:ss'), duration).subscribe(
      (slots) => {
        this.sessionService.slots = slots.filter(
          (slot: ITimeSlot) => {
            if (new Date(slot.endDate) >= new Date()) {
              if (this.sessionService.selectedSlots.startDate) {
                if (new Date(slot.startDate) >= new Date(this.sessionService.selectedSlots.startDate) && new Date(slot.endDate) <= new Date(this.sessionService.selectedSlots.endDate)) {
                  slot.isChecked = true;
                } else if (new Date(slot.startDate) <= new Date(this.sessionService.selectedSlots.startDate) && new Date(slot.endDate) >= new Date(this.sessionService.selectedSlots.endDate)) {
                  this.sessionService.selectedSlots.startDate = slot.startDate;
                  this.sessionService.selectedSlots.endDate = slot.endDate;
                  slot.isChecked = true;
                } else if (this.getMinuteDiff(new Date(this.sessionService.selectedSlots.startDate), new Date(this.sessionService.selectedSlots.endDate)) > duration) {

                  if (new Date(slot.startDate) <= new Date(this.sessionService.selectedSlots.startDate) && new Date(this.sessionService.selectedSlots.startDate) < new Date(slot.endDate)) {
                    this.sessionService.selectedSlots.startDate = slot.startDate;
                    slot.isChecked = true;
                  } else if (new Date(slot.startDate) < new Date(this.sessionService.selectedSlots.endDate) && new Date(this.sessionService.selectedSlots.endDate) <= new Date(slot.endDate)) {
                    this.sessionService.selectedSlots.endDate = slot.endDate;
                    slot.isChecked = true;
                  } else {
                    slot.isChecked = false;
                  }
                }
                else {
                  slot.isChecked = false;
                }
              } else {
                slot.isChecked = false;
              }


              return slot;
            }
          }
        );
        this.spinner = false;
        if (scrollToSession) {
          if (typeof scrollToSession == 'object') {
            setTimeout(() => {
              this.sessionService.slots.forEach((slot, index) => {
                if (slot.id == scrollToSession.id) {
                  //this.viewPort.scrollToIndex(index);
                }
              })

            }, 1000)
          } else {
            setTimeout(() => {
              //this.viewPort.scrollToIndex(scrollToSession);

            }, 1000)
          }

        }
      },
      (err) => {
        this.spinner = false;
      }
    )
  }

  handleChange(event: any) {
    this.sessionService.timeSlot = +event.detail.value;
    this.availableSlot(+event.detail.value);
  }


  changeDay(direction: string) {
    let date = new Date();

    date.setHours(0, 0, 0, 0);

    if (direction == 'forward') {
      this.sessionService.selectedDate = new Date(
        this.sessionService.selectedDate.getFullYear(),
        this.sessionService.selectedDate.getMonth(),
        this.sessionService.selectedDate.getDate() + 1);
      this.availableSlot(this.sessionService.timeSlot);
    }

    if (direction == 'back') {
      if (this.sessionService.selectedDate > date) {
        this.sessionService.selectedDate = new Date(
          this.sessionService.selectedDate.getFullYear(),
          this.sessionService.selectedDate.getMonth(),
          this.sessionService.selectedDate.getDate() - 1);
        this.availableSlot(this.sessionService.timeSlot);
      }
    }
  }

  slotSelected(slot: Session) {
  }

  async validSelection() {
    let session = new Session();
    session.clients = new Array();

    if (this.sessionService.selectedSlots.startDate) {
      session.startDate = this.sessionService.selectedSlots.startDate;
    } else {

      const date = new Date();
      const hour = date.getHours();
      this.sessionService.selectedDate.setHours(hour);

      session.startDate = this.sessionService.selectedDate.toISOString();
    }
    if (this.sessionService.selectedSlots.endDate) {
      session.endDate = this.sessionService.selectedSlots.endDate;
    } else {

      const date = new Date();
      const hour = date.getHours();
      this.sessionService.selectedDate.setHours(hour);

      session.endDate = this.sessionService.selectedDate.toISOString();
    }


    const modalAddSession = await this.modalCtrl.create({
      component: SessionFormComponent,
      id: "modalAddSession",
      componentProps: { session: session }
    });

    modalAddSession.present();

    const { data, role } = await modalAddSession.onWillDismiss();

    if (role == 'create' && data) {

      let alreadySplice = false;

      for (let i = 0; i < this.sessionService.slots.length; i++) {

        if (this.sessionService.slots[i].startDate == data.startDate || this.sessionService.slots[i].endDate == data.endDate) {
          //this.sessionService.slots = [data, ...this.sessionService.slots];
          if (alreadySplice) {
            this.sessionService.slots.splice(i, 0);
          } else {
            this.sessionService.slots.splice(i, 0, data);
            alreadySplice = true;
            i++;
          }


          //this.sessionService.slots[i].animation = 'active';

          // Animation de flash 
          let flashCount = 0;

          const flashInterval = setInterval(() => {
            this.sessionService.slots[i].animation = this.sessionService.slots[i].animation === 'inactive' ? 'active' : 'inactive';
            flashCount++;

            if (flashCount === 6) {
              clearInterval(flashInterval); // Arrête l'animation après 3 flashs
              this.sessionService.slots[i].animation = 'inactive'; // Remet l'animation à l'état initial
            }
          }, 500);
        }

        if (this.sessionService.slots[i].startDate >= data.startDate && this.sessionService.slots[i].startDate < data.endDate) {
          this.sessionService.slots.splice(i, 1); // Supprime l'élément à l'indice 'i'
          i--;
        } else if (this.sessionService.slots[i].endDate > data.startDate && this.sessionService.slots[i].endDate <= data.endDate) {
          this.sessionService.slots.splice(i, 1); // Supprime l'élément à l'indice 'i'
          i--;
        } else {

        }


      }
      this.sessionService.slots = [...this.sessionService.slots];
      this.cancelSelection();
    }

  }

  async editSession(session: Session) {
    if (!session.clients) {
      session.clients = new Array();
    }

    const modalEdition = await this.modalCtrl.create({
      component: SessionFormComponent,
      componentProps: { session: session }
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();

    if (role === 'edit') {
      let editSession: Session = data;
      this.sessionService.selectedDate = new Date(editSession.startDate);

      this.availableSlot(this.sessionService.timeSlot, data);
    }
  }

  async deleteSession(session: Session, index: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: 'Suppression',
      message: 'Etes vous sûr de vouloir supprimer cette session ?',
      buttons: ['Cancel', 'Delete'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    if (role != 'cancel' && role != 'backdrop') {
      this.apiProvider.deleteSession(session).subscribe(
        () => {
          this.availableSlot(this.sessionService.timeSlot, index);
        }
      );
    }


  }

  cancelSelection() {
    this.sessionService.selectedSlots.startDate = null;
    this.sessionService.selectedSlots.endDate = null;
    this.refreshList();

  }

  selectCheckbox(event, selectedSlot: ITimeSlot) {
    //If selected checkbox change to true else false
    if (event.detail.checked) {

      if (this.sessionService.selectedSlots.startDate && this.sessionService.selectedSlots.endDate) {

        if (selectedSlot.startDate >= this.sessionService.selectedSlots.endDate) {

          if (selectedSlot.startDate > this.sessionService.selectedSlots.endDate) {
            this.sessionService.selectedSlots.endDate = selectedSlot.endDate;
          } else {
            this.sessionService.selectedSlots.endDate = selectedSlot.endDate;
          }
        }

        if (selectedSlot.endDate <= this.sessionService.selectedSlots.startDate) {
          this.sessionService.selectedSlots.startDate = selectedSlot.startDate;
        }

      } else {
        this.sessionService.selectedSlots.startDate = selectedSlot.startDate;
        this.sessionService.selectedSlots.endDate = selectedSlot.endDate;
      }

    } else {
      //If selected checkbox change to false

      //Si il reste une seul slot selectionné et qu'on le deselectionne
      if (selectedSlot.startDate == this.sessionService.selectedSlots.startDate && selectedSlot.endDate == this.sessionService.selectedSlots.endDate) {
        this.sessionService.selectedSlots.startDate = null;
        this.sessionService.selectedSlots.endDate = null;
      } else if (selectedSlot.startDate > this.sessionService.selectedSlots.startDate && selectedSlot.endDate < this.sessionService.selectedSlots.endDate) {
        //Si on deselectionne un slot qui est entre le debut et la fin de ce que l'on a selectionner
        this.sessionService.selectedSlots.endDate = selectedSlot.startDate;
      } else {
        if (selectedSlot.startDate == this.sessionService.selectedSlots.startDate) {
          this.sessionService.selectedSlots.startDate = selectedSlot.endDate;
        } else if (selectedSlot.endDate == this.sessionService.selectedSlots.endDate) {
          this.sessionService.selectedSlots.endDate = selectedSlot.startDate
        } else {
          //On fqit rien cqr c'est le dernier de la liste
        }
      }
    }
    this.refreshList();

  }

  refreshList() {
    this.sessionService.slots.filter(
      (slot: ITimeSlot) => {
        this.filter(slot);
      }
    );
  }

  filter(slot: ITimeSlot) {
    if (new Date(slot.endDate) >= new Date()) {
      if (this.sessionService.selectedSlots.startDate) {
        if (new Date(slot.startDate) >= new Date(this.sessionService.selectedSlots.startDate) && new Date(slot.endDate) <= new Date(this.sessionService.selectedSlots.endDate)) {
          slot.isChecked = true;
        } else if (new Date(slot.startDate) <= new Date(this.sessionService.selectedSlots.startDate) && new Date(slot.endDate) >= new Date(this.sessionService.selectedSlots.endDate)) {

          this.sessionService.selectedSlots.startDate = slot.startDate;
          this.sessionService.selectedSlots.endDate = slot.endDate;
          slot.isChecked = true;
        } else {
          slot.isChecked = false;
        }
      } else {
        slot.isChecked = false;
      }


      return slot;
    }
  }

  getMinuteDiff(start: Date, end: Date): number {
    const differenceEnMillisecondes = start.getTime() - end.getTime();
    const differenceEnMinutes = differenceEnMillisecondes / (1000 * 60);

    return Math.abs(differenceEnMinutes);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  hasSelectedSlot(): boolean {
    return this.sessionService.slots?.some(slot => slot.isChecked);
  }

}
